import React, { useEffect, useRef, useState } from "react";
import getText from "Translator";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { getUnreadedNotifications } from "controllers/NotificationController";
import { useMaterialUIController } from "context";
import { displayErrorMessage } from "controllers/validation";
import { useNavigate } from "react-router-dom";
import { setNotification } from "context";
import { setTitle } from "context";
import { setHeader } from "context";
import { setAction } from "context";
import { getAllFilesForuser } from "controllers/FileController";
import {
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { setLoading } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

let menuType = "title";
let SourceMenu = [];

export default function FileList(props) {
  const [controller, dispatch] = useMaterialUIController();
  const [menu, setMenu] = useState([]);
  const [search, setSearch] = useState("");

  const [searchDisplay, setSearchDisplay] = useState(false);
  const [open, setOpen] = useState(false);
  const listMenu = useRef(null);
  const navigate = useNavigate();
  const myRef = useRef(null);
  const serachIconHandler = (value, text = "") => {
    setSearchDisplay(value);
    setSearch(text);
  };
  const createMenu = async (search) => {
    try {
      // setHeader(dispatch, "search-favorite");
      // setTitle(dispatch, {
      //   title: getText("iclc", "fa"),
      //   subtitle: "",
      // });
      setLoading(dispatch, true);
      serachIconHandler(false);
      let res = await getAllFilesForuser({ search }, controller);

      console.log("createMenu", res);
      setLoading(dispatch, false);
      if (res.success) {
        SourceMenu = res.data;
        setMenu(res.data);
      } else {
        SourceMenu = [];
        setMenu([]);
      }
      if (myRef.current !== null) {
        myRef.current.scrollIntoView();
      }
    } catch (err) {
      setLoading(dispatch, false);
      displayErrorMessage("fa");
    }
  };

  const menuClickHandler = async (item, result) => {
    console.log("menuClickHandler", item);
    try {
      let menu = await localStorage.getItem("$menu");
      menu = JSON.parse(menu);
      menu.isMyFile = true;
      menu.limitedFile = false;
      menu.file = item.id;
      menu.nationalCode = item.nationalCode;
      menu.showResultOfFile = result;
      menu.from = "file";
      menu.capsule = item.capsule._id;
      menu.capsuleText = item.capsule.capsuled.text;
      menu.headline = (item.headline + "").toLowerCase();
      menu.visitedpageslist = [];
      await localStorage.setItem("$menu", JSON.stringify(menu));
      navigate("/main/pageview");
    } catch (err) {
      setLoading(dispatch, false);
      displayErrorMessage("fa");
    }
  };

  const setNotificationCount = async () => {
    try {
      if (controller.authenticated) {
        let result = await getUnreadedNotifications(controller);
        if (result.success) {
          if (result.data !== controller.notification) {
            setNotification(dispatch, result.data);
          }
        } else {
        }
      }
    } catch (err) {}
  };
  useEffect(() => {
    setNotificationCount();
    createMenu("");
    setTitle(dispatch, {
      title: getText("listoffiles", "fa"),
      subtitle: "",
    });
    setHeader(dispatch, "search-notification-backpage");

    return () => {
      setAction(dispatch, "");
      setHeader(dispatch, "");
      setLoading(dispatch, false);
    };
  }, []);
  useEffect(() => {
    (async () => {
      if (controller.action) {
        if (controller.action.startsWith("backpage")) {
          navigate("main/complaints");
        } else if (controller.action.startsWith("search")) {
          if (searchDisplay) {
            setSearch("");
            setMenu(SourceMenu);
          }
          setSearchDisplay(!searchDisplay);
        }
        dispatch({
          type: "action",
          payload: { action: "" },
        });
      }
    })();
  }, [controller.action]);
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("questions", "fa")}
        // searchHandler={searchHandler}
      />

      <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
        <List
          id="mainlist"
          key="mainlist"
          ref={listMenu}
          style={{ marginBottom: 150 }}
        >
          {menu &&
            menu.map((item, index) => (
              <ListItem
                className="list"
                key={"btn" + index}
                button
                style={{ borderBottom: "1px solid #039dfc" }}
                onClick={() => {
                  menuClickHandler(item, false);
                }}
              >
                {/* {menuType === "files" && "fa" === "fa" && (
                  <ListItemIcon
                    style={{ width: 35, minWidth: 35 }}
                    onClick={() => {
                      menuClickHandler(item, true);
                    }}
                  >
                    <ImportContactsIcon
                      style={{ fontSize: 20, color: "#039dfc" }}
                    />
                  </ListItemIcon>
                )} */}
                <ListItemText
                // ref={index === 0 ? myRef : null}
                >
                  <div style={{ color: "#039dfc", fontWeight: "bold" }}>
                    {`${item.patientName}  ${item.patientFamily}   (${item.patientNationalCode})`}
                  </div>
                  <div style={{ color: "gray", fontWeight: "bold" }}>
                    {item.capsule.capsuled.text}
                  </div>
                </ListItemText>

                {/* {menuType === "files" && "fa" === "en" && (
                  <ListItemIcon
                    style={{ width: 35, minWidth: 35 }}
                    onClick={() => {
                      menuClickHandler(item, true);
                    }}
                  >
                    <ImportContactsIcon
                      style={{ fontSize: 20, color: "#039dfc" }}
                    />
                  </ListItemIcon>
                )} */}
              </ListItem>
            ))}
        </List>
      </div>

      {searchDisplay && (
        <Paper
          component="form"
          style={{
            padding: "1px 4px",
            display: "flex",
            alignItems: "center",
            margin: 0,
            left: 0,
            with: "100% !important",
            right: 0,
            bottom: 45,
            position: "fixed",
            borderRadius: 0,
            backgroundColor: "#ffc7d4",
            zIndex: 9999,
          }}
        >
          <IconButton
            color="primary"
            ria-label="HighlightOffIcon"
            onClick={() => {
              setSearch("");
              setSearchDisplay(false);
              createMenu("");
            }}
          >
            <CloseIcon />
          </IconButton>
          <InputBase
            value={search}
            fullWidth={true}
            autoFocus={true}
            onChange={(event) => {
              console.log(event.target.value);
              setSearch(event.target.value);
              if (event.target.value.length > 0) {
                let smenu = [];
                console.log("ssss", SourceMenu);
                smenu = SourceMenu.filter(
                  (a) =>
                    a.capsule.capsuled.text
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase()) ||
                    a.patientFamily
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase()) ||
                    a.patientName
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase()) ||
                    a.patientNationalCode
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase())
                );

                setMenu(smenu);
              } else {
                setMenu(SourceMenu);
              }
            }}
          />

          <IconButton
            color="primary"
            // className={classes.iconButton}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      )}
      {/* {searchDisplay && (
        <Paper component="form" className="root" Ï>
          <IconButton
            color="primary"
            className="iconButton"
            aria-label="CloseIcon"
            onClick={() => {
              setSearch("");
              setSearchDisplay(false);
              createMenu("");
            }}
          >
            <CloseIcon />
          </IconButton>
          <InputBase
            className="input"
            value={search}
            fullWidth={true}
            autoFocus={true}
            onChange={(event) => {
              setSearch(event.target.value);
              if (event.target.value.length > 0) {
                let smenu = [];
                if (menuType === "files") {
                  smenu = SourceMenu.filter(
                    (a) =>
                      a.text
                        .toLowerCase()
                        .includes(event.target.value.toLowerCase()) ||
                      a.nationalCode
                        .toLowerCase()
                        .includes(event.target.value.toLowerCase())
                  );
                } else {
                  smenu = SourceMenu.filter((a) =>
                    a.text
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase())
                  );
                }
                setMenu(smenu);
              } else {
                setMenu(SourceMenu);
              }
            }}
          />
          <IconButton
            color="primary"
            className="iconButton"
            aria-label="search"
            onClick={() => {
              if (search.length > 0) {
                let smenu = [];
                if (menuType === "files") {
                  smenu = SourceMenu.filter(
                    (a) =>
                      a.text.toLowerCase().includes(search.toLowerCase()) ||
                      a.nationalCode
                        .toLowerCase()
                        .includes(search.toLowerCase())
                  );
                } else {
                  smenu = SourceMenu.filter((a) =>
                    a.text.toLowerCase().includes(search.toLowerCase())
                  );
                }
                setMenu(smenu);
              } else {
                setMenu(SourceMenu);
              }
            }}
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      )} */}
      <Footer />
    </DashboardLayout>
  );
}
